/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityIncognitoSpyIcon16Light } from './SecurityIncognitoSpyIcon16Light';
import { SecurityIncognitoSpyIcon16Regular } from './SecurityIncognitoSpyIcon16Regular';
import { SecurityIncognitoSpyIcon16Solid } from './SecurityIncognitoSpyIcon16Solid';
import { SecurityIncognitoSpyIcon20Light } from './SecurityIncognitoSpyIcon20Light';
import { SecurityIncognitoSpyIcon20Regular } from './SecurityIncognitoSpyIcon20Regular';
import { SecurityIncognitoSpyIcon20Solid } from './SecurityIncognitoSpyIcon20Solid';
import { SecurityIncognitoSpyIcon24Regular } from './SecurityIncognitoSpyIcon24Regular';
import { SecurityIncognitoSpyIcon24Solid } from './SecurityIncognitoSpyIcon24Solid';
import { SecurityIncognitoSpyIcon32Regular } from './SecurityIncognitoSpyIcon32Regular';
import { SecurityIncognitoSpyIcon64Regular } from './SecurityIncognitoSpyIcon64Regular';
var sizes = {
    16: {
        light: SecurityIncognitoSpyIcon16Light,
        regular: SecurityIncognitoSpyIcon16Regular,
        solid: SecurityIncognitoSpyIcon16Solid,
    },
    20: {
        light: SecurityIncognitoSpyIcon20Light,
        regular: SecurityIncognitoSpyIcon20Regular,
        solid: SecurityIncognitoSpyIcon20Solid,
    },
    24: {
        regular: SecurityIncognitoSpyIcon24Regular,
        solid: SecurityIncognitoSpyIcon24Solid,
    },
    32: {
        regular: SecurityIncognitoSpyIcon32Regular,
    },
    64: {
        regular: SecurityIncognitoSpyIcon64Regular,
    },
};
export var SecurityIncognitoSpyIcon = forwardRef('SecurityIncognitoSpyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
